import {
  APP,
  DEFAULT_BLACK_COLOR,
  DEFAULT_WHITE_COLOR,
  DETAIL_TABLE_BACKGROUND_COLOR,
  INVOICES_TABLE_CELL_BORDER_COLOR,
  ROW_EVEN_COLOR,
  TABLE_ODD_ROW_COLOR
} from 'src/style/variable';
export const GuarantorCellStyle = {
  width: '12%'
  // width: '200px',
  // paddingLeft: '2rem',
};

export const GuarantorHeaderStyle = {
  padding: '10px'
  // paddingLeft: '2rem'
};

export const PlanHeaderStyle = {
  padding: '15px'
  // paddingLeft: '2rem'
};

export const fixedCellwidth80 = {
  width: '12%',
  maxWidth: '80px'
};

export const CCMPatientPlanRowLogsStyle = {
  padding: '14px 10px'
};

//  '@media (min-width:800px)' = {
//  const paddingStyle = {
//     paddingLeft : '0px'
//  }
// }

export const fixedCellwidth100 = {
  width: '18%',
  maxWidth: '100px',
  fontSize: '0.875rem'
};

export const tableCellWidth20 = {
  width: '20%'
};

export const tableCellWidth5 = {
  width: '5%'
};

export const tableCellWidth10 = {
  width: '10%'
};

export const tableCellWidth13 = {
  width: '13%'
};

export const tableCellWidth17 = {
  width: '17%'
};

export const tableCellWidth15 = {
  width: '15%'
};

export const tableCellWidth18 = {
  width: '18%',
  fontSize: '0.875rem'
};
export const tableCellWidth30 = {
  width: '30%',
  fontSize: '0.875rem'
};
export const tableCellWidth25 = {
  width: '25%',
  fontSize: '0.875rem'
};

export const tableCellWidth8 = {
  width: '10%',
  fontSize: '0.875rem'
};

export const planNameStyle = {
  width: '12%',
  paddingLeft: '6rem'
};

export const tableColumnWidth = {
  width: '12%'
};
export const tableColumnWords = {
  textOverflow: 'ellipsis',
  fontSize: '14px'
};
// export const tableWidth = {
//   '@media (min-width:700px)' : {
//     // maxBodyHeight : '70vh',
//     overflowX: 'hidden'
//   }
// };

export const textAlignRight = {
  textAlign: 'right'
};

export const tableCellWidth12 = {
  width: '12%'
};

export const phoneNumberWidth = {
  width: '12%'
  // textAlign : 'right'
};

export const BorderAndBackgroundColor = {
  backgroundColor: DETAIL_TABLE_BACKGROUND_COLOR,
  borderColor: INVOICES_TABLE_CELL_BORDER_COLOR,
  overflow: 'hidden',
  width: '10%',
  textOverflow: 'ellipsis',
  fontSize: '0.875rem'
};
export const tableBoxShadow =
  '-0.5px 0px 0px 0px rgba(0,0,0,0.2), 0px -0.5px 0px 0px rgba(0,0,0,0.14), 1px 0px 0px 0px rgba(0,0,0,0.12)';

export const DetailsPanelTableBoxShadow =
  '0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12)';

export const requestSentHeader = {
  paddingRight: '2rem'
};

export const remainderIcon = {
  justifyContent: 'center',
  paddingLeft: '1rem'
};

export const dateOfPaymentCell = {
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem'
};

export const amountCell = {
  textAlign: 'right',
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem'
};

export const headerRightAlign = {
  textAlign: 'right'
};

export const paymentTableHeader = {
  borderBottom: '1px solid lightgrey',
  color: DEFAULT_BLACK_COLOR,
  fontFamily: APP.FONT_FAMILY.MEDIUM,
  fontSize: '1rem',
  flexDirection: 'row',
  paddingBottom: '0.5rem',
  paddingTop: '0.5rem'
};

export const paymentTableStyle = {
  border: '1px solid lightgrey',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  boxShadow: `0px 0px ${DEFAULT_WHITE_COLOR}`
};

export const tableEvenRow = {
  fontSize: '0.875rem',
  backgroundColor: TABLE_ODD_ROW_COLOR
};

export const tableOddRow = {
  fontSize: '0.875rem',
  backgroundColor: ROW_EVEN_COLOR
};

export const paymentPlanHeaderStyleAndCellStyle = {
  padding: '12px'
};
